import { Avatar, Box, SxProps } from "@mui/material";
import { Image, defaultIconStyle, defaultIconStyleNew } from "./AvatarCustom.style";
import React, { FC, useState } from "react";

import WellnessTagIcon from "../Icons/WellnessTagIcon";
import SocOverdueIcon from "../Icons/SocOverdueIcon";
import { DogIcon } from "../Icons";

interface IAvatarCustomProps {
  image?: string;
  name?: string;
  width: number;
  height: number;
  sx?: SxProps;
  className?: string
  isBorder?: string;
  avatarStyleToggle?: boolean;
  avatarStyleClass?: string;
  isWellnessMember?: boolean;
  isPlanOverdue?: boolean;
  wellnessIconHeight?: number;
  wellnessIconWidth?: number;
  wellnessIconCordinate?: boolean;
  isDashBoardPetCardBooking?: { wellnessIconCoordinates: { x: string; y: string },
  wellnessIcon: { width: number, height: number } } | undefined;
  textClass?: string;
  defaultDogImage?: boolean
}

const AvatarCustom: FC<IAvatarCustomProps> = ({ image, name, width, height, sx, className, isBorder,
  avatarStyleToggle=false,
  avatarStyleClass,
  isWellnessMember=false,
  wellnessIconHeight=24,
  isPlanOverdue=false,
  wellnessIconWidth=24,
  isDashBoardPetCardBooking, textClass, defaultDogImage }) => {
  const [imageError, setImageError] = useState(false);

  const showImage = (image || defaultDogImage) && !imageError;

  return <Box style={{ display: "inline-block" }} sx={sx} className={`${className} relative`}>
    {
      showImage ?
        <Avatar sx={{ width, height, border: isBorder ? `2px solid ${isBorder}`: undefined,
          background: defaultDogImage ?"gray" :"transparent" }} className={`${avatarStyleClass}`}>
          {defaultDogImage ?
            <DogIcon width={30} height={30} /> :
            <Image src={image} alt={name} onError={() => setImageError(true)} />}
        </Avatar> :
        <Box sx={avatarStyleToggle ? defaultIconStyleNew : defaultIconStyle} style={{
          width, height,
          border: isBorder ? `2px solid ${isBorder}` : undefined,
        }}
        className={textClass}
        >
          {name?.charAt(0).toUpperCase()}
        </Box>
    }
    {isWellnessMember && <WellnessTagIcon
      width={isDashBoardPetCardBooking?.wellnessIcon?.width || wellnessIconWidth}
      height={isDashBoardPetCardBooking?.wellnessIcon?.height || wellnessIconHeight}
      transformX={isDashBoardPetCardBooking?.wellnessIconCoordinates.x || "42"}
      transformY={isDashBoardPetCardBooking?.wellnessIconCoordinates.y || "-22" }
    />}
    {isPlanOverdue && <SocOverdueIcon
      width={isDashBoardPetCardBooking?.wellnessIcon?.width || wellnessIconWidth}
      height={isDashBoardPetCardBooking?.wellnessIcon?.height || wellnessIconHeight}
      transformX={isDashBoardPetCardBooking?.wellnessIconCoordinates.x || "42"}
      transformY={isDashBoardPetCardBooking?.wellnessIconCoordinates.y || "-22" }
    />}
  </Box>;
};

export default AvatarCustom;
